import React from 'react'
import DateProvider from './DateProvider'
import ThemeProvider from './ThemeProvider'

type Props = { children: React.ReactNode }

function MainProvider({ children }: Props) {
  return (
    <ThemeProvider>
      <DateProvider>{children}</DateProvider>
    </ThemeProvider>
  )
}

export default MainProvider
